:host {
  display: block;
}
.input-checked{
  background-color: var(--mainColor);
  border:  1px solid transparent;
}
.input-unchecked{
  border:  1px solid var(--mainColor);

}